/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/compound-assessments';

type Props = {
  id?: string;
  message?: React.ReactNode;
  className?: string;
};

const styles = {
  root: css`
    color: var(--cds-color-feedback-error);
  `,
};
const ValidationError: React.FC<Props> = ({ message, className, id }: Props) => {
  return (
    <Typography2
      component="p"
      variant="bodyPrimary"
      css={styles.root}
      className={className}
      id={id ? `validation-error-${id}` : undefined}
    >
      {message || _t("You haven't answered this question")}
    </Typography2>
  );
};

export default ValidationError;
